"use client"

import { Boilerplate } from "@prisma/client"
import { useEffect, useState } from "react"

import ReductionPopupModal from "./reduction-popup-modal"

export default function ReductionPopup({
  boilerplate,
}: {
  boilerplate: Boilerplate
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true)
    }, 7500)

    return () => clearTimeout(timer)
  }, [])
  return (
    <ReductionPopupModal
      boilerplate={boilerplate}
      isOpen={isModalOpen}
      setIsOpen={setIsModalOpen}
    />
  )
}
